module.exports = __webpack_public_path__ + "img/cloud_bottom@2x.154a2350.png";